import { FunctionComponent } from "react";
import { CheckIcon, ArrowTopRightOnSquareIcon } from "@heroicons/react/24/solid";

import { CustomButton, Modal } from "@helloaudio/ui";

interface SuccessModalProps {
  customColor?: string;
  visible?: boolean;
  onContinue: () => void;
}

const SuccessModal: FunctionComponent<SuccessModalProps> = ({
  visible,
  onContinue,
  customColor,
}) => {
  return (
    <Modal
      visible={visible}
      actions={[
        <CustomButton
          key="continue"
          accent="primary"
          onClick={onContinue}
          trailingIcon={ArrowTopRightOnSquareIcon}
          style={customColor ? { backgroundColor: customColor } : undefined}
        >
          Continue
        </CustomButton>,
      ]}
    >
      <div className="tw-p-4">
        <div className="tw-mx-auto tw-flex tw-items-center tw-justify-center tw-h-12 tw-w-12 tw-rounded-full tw-bg-green-100">
          <CheckIcon className="tw-h-8 tw-w-8 tw-text-green-600" aria-hidden="true" />
        </div>
        <div className="tw-mt-3 tw-text-center sm:tw-mt-5">
          <h3
            className="tw-text-lg tw-leading-6 tw-font-medium tw-text-gray-900"
            id="headlessui-dialog-title-:r1i:"
          >
            Thanks!
          </h3>
          <div className="tw-mt-2 tw-px-8">
            <p className="tw-text-sm tw-text-gray-500">
              Please check your inbox for your link, or access using the button below.
            </p>
          </div>
        </div>
        <span className="tw-block tw-mt-4 tw-text-sm tw-text-gray-900 tw-italic">
          No email received? Reach out to the creator or contact{" "}
          <span className="tw-font-semibold">Hello Audio</span> at{" "}
          <a className="tw-text-indigo-800" href="mailto:support@helloaudio.fm">
            support@helloaudio.fm
          </a>
        </span>
      </div>
    </Modal>
  );
};

export default SuccessModal;
